export interface ISearchState {
  transactionSearch: Record<string, any[]>;
  error: string;
  isFetching: boolean;
  currentSearchInput: string;
}

export enum SearchScopeEnum {
  USER = 'user',
  LOCATION = 'location',
  COMPANY = 'company',
  TRANSACTION = 'transaction',
}
